'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var check_1 = require("./check");
var Json;
(function (Json) {
    function resolve(value, reviver) {
        var isValidJSON = false;
        var parsedJSON = null;
        try {
            parsedJSON = JSON.parse(value, reviver);
            isValidJSON = true;
        }
        catch (error) {
        }
        return { isValid: isValidJSON, result: parsedJSON };
    }
    Json.resolve = resolve;
    function encode(value, replacer, space) {
        return JSON.stringify(value, replacer, space);
    }
    Json.encode = encode;
    function decode(value, reviver, defaultValue) {
        if (!value) {
            return defaultValue;
        }
        if (check_1.Check.isObjectLike(value)) {
            return value;
        }
        var result = defaultValue;
        try {
            result = JSON.parse(value, reviver);
        }
        catch (error) {
        }
        return result;
    }
    Json.decode = decode;
})(Json = exports.Json || (exports.Json = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/json.ts
// module id = 12
// module chunks = 0 1